import leeCoachEpicClient from 'bundles/epic/clients/leeCoach';

/**
 * Coursera AI Brand Update.
 *
 * Migration guide: https://coursera.atlassian.net/wiki/spaces/PE/pages/5432999942
 */
export const isCoachBrandUpdateEnabled = (): boolean => {
  return leeCoachEpicClient.get('enableBrandUpdate');
};
